export const SHIFT_LIST_REQUEST = 'SHIFT_LIST_REQUEST';
export const SHIFT_LIST_SUCCESS = 'SHIFT_LIST_SUCCESS';
export const SHIFT_LIST_FAIL = 'SHIFT_LIST_FAIL';
export const SHIFT_HAS_MORE = 'SHIFT_HAS_MORE';
export const SHIFT_LIMIT = 10;
